/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetInvitationsParams,
  InvitationDTO,
  InvitationFilterDTO,
  PageInvitationDTO,
  SelfInvitationRequestDTO,
  TransactionRecordDTO,
  VerifyOtpRequest
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Update details for an existing invitation
 * @summary Update invitation details
 */
export const updateDetails = (
    invitationDTO: InvitationDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<InvitationDTO>(
      {url: `/frontend/invitations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: invitationDTO
    },
      options);
    }
  


export const getUpdateDetailsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDetails>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDetails>>, TError,{data: InvitationDTO}, TContext> => {

const mutationKey = ['updateDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDetails>>, {data: InvitationDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateDetails(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updateDetails>>>
    export type UpdateDetailsMutationBody = InvitationDTO
    export type UpdateDetailsMutationError = unknown

    /**
 * @summary Update invitation details
 */
export const useUpdateDetails = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDetails>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDetails>>,
        TError,
        {data: InvitationDTO},
        TContext
      > => {

      const mutationOptions = getUpdateDetailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create a new invitation
 * @summary Create invitation
 */
export const createInvitation = (
    invitationDTO: InvitationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InvitationDTO>(
      {url: `/frontend/invitations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitationDTO, signal
    },
      options);
    }
  


export const getCreateInvitationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: InvitationDTO}, TContext> => {

const mutationKey = ['createInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvitation>>, {data: InvitationDTO}> = (props) => {
          const {data} = props ?? {};

          return  createInvitation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createInvitation>>>
    export type CreateInvitationMutationBody = InvitationDTO
    export type CreateInvitationMutationError = unknown

    /**
 * @summary Create invitation
 */
export const useCreateInvitation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInvitation>>,
        TError,
        {data: InvitationDTO},
        TContext
      > => {

      const mutationOptions = getCreateInvitationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Verify OTP for phone number
 * @summary Verify phone OTP
 */
export const verifyPhoneOtp = (
    verifyOtpRequest: VerifyOtpRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/frontend/invitations/verify-otp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyOtpRequest, signal
    },
      options);
    }
  


export const getVerifyPhoneOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneOtp>>, TError,{data: VerifyOtpRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneOtp>>, TError,{data: VerifyOtpRequest}, TContext> => {

const mutationKey = ['verifyPhoneOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyPhoneOtp>>, {data: VerifyOtpRequest}> = (props) => {
          const {data} = props ?? {};

          return  verifyPhoneOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyPhoneOtpMutationResult = NonNullable<Awaited<ReturnType<typeof verifyPhoneOtp>>>
    export type VerifyPhoneOtpMutationBody = VerifyOtpRequest
    export type VerifyPhoneOtpMutationError = unknown

    /**
 * @summary Verify phone OTP
 */
export const useVerifyPhoneOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPhoneOtp>>, TError,{data: VerifyOtpRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyPhoneOtp>>,
        TError,
        {data: VerifyOtpRequest},
        TContext
      > => {

      const mutationOptions = getVerifyPhoneOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Validate OTP for an invitation
 * @summary Validate OTP
 */
export const validateOTP = (
    invitationDTO: InvitationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InvitationDTO>(
      {url: `/frontend/invitations/validate-otp`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitationDTO, signal
    },
      options);
    }
  


export const getValidateOTPMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateOTP>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateOTP>>, TError,{data: InvitationDTO}, TContext> => {

const mutationKey = ['validateOTP'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateOTP>>, {data: InvitationDTO}> = (props) => {
          const {data} = props ?? {};

          return  validateOTP(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateOTPMutationResult = NonNullable<Awaited<ReturnType<typeof validateOTP>>>
    export type ValidateOTPMutationBody = InvitationDTO
    export type ValidateOTPMutationError = unknown

    /**
 * @summary Validate OTP
 */
export const useValidateOTP = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateOTP>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateOTP>>,
        TError,
        {data: InvitationDTO},
        TContext
      > => {

      const mutationOptions = getValidateOTPMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Send OTP to phone number
 * @summary Send phone OTP
 */
export const sendPhoneOtp = (
    phoneNumber: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<VerifyOtpRequest>(
      {url: `/frontend/invitations/send-otp/${phoneNumber}`, method: 'POST', signal
    },
      options);
    }
  


export const getSendPhoneOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPhoneOtp>>, TError,{phoneNumber: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPhoneOtp>>, TError,{phoneNumber: string}, TContext> => {

const mutationKey = ['sendPhoneOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPhoneOtp>>, {phoneNumber: string}> = (props) => {
          const {phoneNumber} = props ?? {};

          return  sendPhoneOtp(phoneNumber,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendPhoneOtpMutationResult = NonNullable<Awaited<ReturnType<typeof sendPhoneOtp>>>
    
    export type SendPhoneOtpMutationError = unknown

    /**
 * @summary Send phone OTP
 */
export const useSendPhoneOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPhoneOtp>>, TError,{phoneNumber: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendPhoneOtp>>,
        TError,
        {phoneNumber: string},
        TContext
      > => {

      const mutationOptions = getSendPhoneOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Request a self-invitation
 * @summary Request self invitation
 */
export const requestSelfInvitation = (
    selfInvitationRequestDTO: SelfInvitationRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/frontend/invitations/self`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfInvitationRequestDTO, signal
    },
      options);
    }
  


export const getRequestSelfInvitationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSelfInvitation>>, TError,{data: SelfInvitationRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestSelfInvitation>>, TError,{data: SelfInvitationRequestDTO}, TContext> => {

const mutationKey = ['requestSelfInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestSelfInvitation>>, {data: SelfInvitationRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  requestSelfInvitation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestSelfInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof requestSelfInvitation>>>
    export type RequestSelfInvitationMutationBody = SelfInvitationRequestDTO
    export type RequestSelfInvitationMutationError = unknown

    /**
 * @summary Request self invitation
 */
export const useRequestSelfInvitation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestSelfInvitation>>, TError,{data: SelfInvitationRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestSelfInvitation>>,
        TError,
        {data: SelfInvitationRequestDTO},
        TContext
      > => {

      const mutationOptions = getRequestSelfInvitationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Process initial deposit for an invitation
 * @summary Process initial deposit
 */
export const processInitialDeposit = (
    invitationDTO: InvitationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InvitationDTO>(
      {url: `/frontend/invitations/process-deposit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitationDTO, signal
    },
      options);
    }
  


export const getProcessInitialDepositMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processInitialDeposit>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof processInitialDeposit>>, TError,{data: InvitationDTO}, TContext> => {

const mutationKey = ['processInitialDeposit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processInitialDeposit>>, {data: InvitationDTO}> = (props) => {
          const {data} = props ?? {};

          return  processInitialDeposit(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProcessInitialDepositMutationResult = NonNullable<Awaited<ReturnType<typeof processInitialDeposit>>>
    export type ProcessInitialDepositMutationBody = InvitationDTO
    export type ProcessInitialDepositMutationError = unknown

    /**
 * @summary Process initial deposit
 */
export const useProcessInitialDeposit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processInitialDeposit>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processInitialDeposit>>,
        TError,
        {data: InvitationDTO},
        TContext
      > => {

      const mutationOptions = getProcessInitialDepositMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get invitations with filtering and pagination
 * @summary Get invitations
 */
export const getInvitations = (
    invitationFilterDTO: InvitationFilterDTO,
    params: GetInvitationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageInvitationDTO>(
      {url: `/frontend/invitations/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitationFilterDTO,
        params, signal
    },
      options);
    }
  


export const getGetInvitationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getInvitations>>, TError,{data: InvitationFilterDTO;params: GetInvitationsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getInvitations>>, TError,{data: InvitationFilterDTO;params: GetInvitationsParams}, TContext> => {

const mutationKey = ['getInvitations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getInvitations>>, {data: InvitationFilterDTO;params: GetInvitationsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  getInvitations(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetInvitationsMutationResult = NonNullable<Awaited<ReturnType<typeof getInvitations>>>
    export type GetInvitationsMutationBody = InvitationFilterDTO
    export type GetInvitationsMutationError = unknown

    /**
 * @summary Get invitations
 */
export const useGetInvitations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getInvitations>>, TError,{data: InvitationFilterDTO;params: GetInvitationsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getInvitations>>,
        TError,
        {data: InvitationFilterDTO;params: GetInvitationsParams},
        TContext
      > => {

      const mutationOptions = getGetInvitationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Check if an invitation exists for the phone number
 * @summary Check invitation exists
 */
export const isInvitationExists = (
    invitationDTO: InvitationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/frontend/invitations/exists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitationDTO, signal
    },
      options);
    }
  


export const getIsInvitationExistsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof isInvitationExists>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof isInvitationExists>>, TError,{data: InvitationDTO}, TContext> => {

const mutationKey = ['isInvitationExists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof isInvitationExists>>, {data: InvitationDTO}> = (props) => {
          const {data} = props ?? {};

          return  isInvitationExists(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IsInvitationExistsMutationResult = NonNullable<Awaited<ReturnType<typeof isInvitationExists>>>
    export type IsInvitationExistsMutationBody = InvitationDTO
    export type IsInvitationExistsMutationError = unknown

    /**
 * @summary Check invitation exists
 */
export const useIsInvitationExists = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof isInvitationExists>>, TError,{data: InvitationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof isInvitationExists>>,
        TError,
        {data: InvitationDTO},
        TContext
      > => {

      const mutationOptions = getIsInvitationExistsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get transaction details by ID
 * @summary Get transaction by ID
 */
export const getTransactionById = (
    transactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransactionRecordDTO>(
      {url: `/frontend/invitations/transaction/${transactionId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTransactionByIdInfiniteQueryKey = (transactionId?: string,) => {
    return [
    'infinite', `/frontend/invitations/transaction/${transactionId}`
    ] as const;
    }

export const getGetTransactionByIdQueryKey = (transactionId?: string,) => {
    return [
    `/frontend/invitations/transaction/${transactionId}`
    ] as const;
    }

    
export const getGetTransactionByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getTransactionById>>>, TError = unknown>(transactionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransactionByIdInfiniteQueryKey(transactionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionById>>> = ({ signal }) => getTransactionById(transactionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transactionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTransactionByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactionById>>>
export type GetTransactionByIdInfiniteQueryError = unknown


export function useGetTransactionByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransactionById>>>, TError = unknown>(
 transactionId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionById>>,
          TError,
          Awaited<ReturnType<typeof getTransactionById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransactionByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransactionById>>>, TError = unknown>(
 transactionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionById>>,
          TError,
          Awaited<ReturnType<typeof getTransactionById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransactionByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransactionById>>>, TError = unknown>(
 transactionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get transaction by ID
 */

export function useGetTransactionByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransactionById>>>, TError = unknown>(
 transactionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTransactionByIdInfiniteQueryOptions(transactionId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTransactionByIdQueryOptions = <TData = Awaited<ReturnType<typeof getTransactionById>>, TError = unknown>(transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransactionByIdQueryKey(transactionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionById>>> = ({ signal }) => getTransactionById(transactionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transactionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTransactionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactionById>>>
export type GetTransactionByIdQueryError = unknown


export function useGetTransactionById<TData = Awaited<ReturnType<typeof getTransactionById>>, TError = unknown>(
 transactionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionById>>,
          TError,
          Awaited<ReturnType<typeof getTransactionById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransactionById<TData = Awaited<ReturnType<typeof getTransactionById>>, TError = unknown>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionById>>,
          TError,
          Awaited<ReturnType<typeof getTransactionById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransactionById<TData = Awaited<ReturnType<typeof getTransactionById>>, TError = unknown>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get transaction by ID
 */

export function useGetTransactionById<TData = Awaited<ReturnType<typeof getTransactionById>>, TError = unknown>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTransactionByIdQueryOptions(transactionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get invitation by phone number
 * @summary Get invitation by phone
 */
export const getInvitationByPhoneNumber = (
    phoneNumber: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InvitationDTO>(
      {url: `/frontend/invitations/phone/${phoneNumber}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInvitationByPhoneNumberInfiniteQueryKey = (phoneNumber?: string,) => {
    return [
    'infinite', `/frontend/invitations/phone/${phoneNumber}`
    ] as const;
    }

export const getGetInvitationByPhoneNumberQueryKey = (phoneNumber?: string,) => {
    return [
    `/frontend/invitations/phone/${phoneNumber}`
    ] as const;
    }

    
export const getGetInvitationByPhoneNumberInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>>, TError = unknown>(phoneNumber: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationByPhoneNumberInfiniteQueryKey(phoneNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>> = ({ signal }) => getInvitationByPhoneNumber(phoneNumber, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(phoneNumber), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetInvitationByPhoneNumberInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>>
export type GetInvitationByPhoneNumberInfiniteQueryError = unknown


export function useGetInvitationByPhoneNumberInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>>, TError = unknown>(
 phoneNumber: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationByPhoneNumber>>,
          TError,
          Awaited<ReturnType<typeof getInvitationByPhoneNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetInvitationByPhoneNumberInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>>, TError = unknown>(
 phoneNumber: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationByPhoneNumber>>,
          TError,
          Awaited<ReturnType<typeof getInvitationByPhoneNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetInvitationByPhoneNumberInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>>, TError = unknown>(
 phoneNumber: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get invitation by phone
 */

export function useGetInvitationByPhoneNumberInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>>, TError = unknown>(
 phoneNumber: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetInvitationByPhoneNumberInfiniteQueryOptions(phoneNumber,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetInvitationByPhoneNumberQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError = unknown>(phoneNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationByPhoneNumberQueryKey(phoneNumber);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>> = ({ signal }) => getInvitationByPhoneNumber(phoneNumber, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(phoneNumber), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetInvitationByPhoneNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>>
export type GetInvitationByPhoneNumberQueryError = unknown


export function useGetInvitationByPhoneNumber<TData = Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError = unknown>(
 phoneNumber: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationByPhoneNumber>>,
          TError,
          Awaited<ReturnType<typeof getInvitationByPhoneNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetInvitationByPhoneNumber<TData = Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError = unknown>(
 phoneNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationByPhoneNumber>>,
          TError,
          Awaited<ReturnType<typeof getInvitationByPhoneNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetInvitationByPhoneNumber<TData = Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError = unknown>(
 phoneNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get invitation by phone
 */

export function useGetInvitationByPhoneNumber<TData = Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError = unknown>(
 phoneNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationByPhoneNumber>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetInvitationByPhoneNumberQueryOptions(phoneNumber,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get list of allowed domains for self-invitation
 * @summary Get allowed domains
 */
export const allowedDomains = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/frontend/invitations/allowed-domains`, method: 'GET', signal
    },
      options);
    }
  



export const getAllowedDomainsInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/invitations/allowed-domains`
    ] as const;
    }

export const getAllowedDomainsQueryKey = () => {
    return [
    `/frontend/invitations/allowed-domains`
    ] as const;
    }

    
export const getAllowedDomainsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof allowedDomains>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllowedDomainsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allowedDomains>>> = ({ signal }) => allowedDomains(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AllowedDomainsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof allowedDomains>>>
export type AllowedDomainsInfiniteQueryError = unknown


export function useAllowedDomainsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof allowedDomains>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allowedDomains>>,
          TError,
          Awaited<ReturnType<typeof allowedDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAllowedDomainsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof allowedDomains>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allowedDomains>>,
          TError,
          Awaited<ReturnType<typeof allowedDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAllowedDomainsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof allowedDomains>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get allowed domains
 */

export function useAllowedDomainsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof allowedDomains>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAllowedDomainsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllowedDomainsQueryOptions = <TData = Awaited<ReturnType<typeof allowedDomains>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllowedDomainsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allowedDomains>>> = ({ signal }) => allowedDomains(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AllowedDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof allowedDomains>>>
export type AllowedDomainsQueryError = unknown


export function useAllowedDomains<TData = Awaited<ReturnType<typeof allowedDomains>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allowedDomains>>,
          TError,
          Awaited<ReturnType<typeof allowedDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAllowedDomains<TData = Awaited<ReturnType<typeof allowedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allowedDomains>>,
          TError,
          Awaited<ReturnType<typeof allowedDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAllowedDomains<TData = Awaited<ReturnType<typeof allowedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get allowed domains
 */

export function useAllowedDomains<TData = Awaited<ReturnType<typeof allowedDomains>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allowedDomains>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAllowedDomainsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




